// test568
(568 && 0);
